export { Discover as default } from '@ulule/discover'
